import { OfferStatus } from '../../types/offers';
import { STATUS_BADGE, STATUS_LABELS } from './offerReviewModel';

export default function OfferStatusChip({ status }: { status: OfferStatus }) {
  return <span className={`admin-badge ${STATUS_BADGE[status] ?? 'neutral'}`}>{STATUS_LABELS[status] ?? status}</span>;
}
